/* eslint-disable react/no-unused-state */
// import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { View, Alert, Dimensions, Platform, ImageBackground, TouchableOpacity } from 'react-native'

import * as util from 'x/utils/util'
import _ from 'lodash'
import HStack from 'xui/components/HStack'
import p from 'x/config/platform-specific'
import XContainer from 'xui/components/XContainer'
import XIcon from 'xui/components/XIcon'
// import { TouchableOpacity } from 'react-native-gesture-handler'
import { COLORS, STYLES } from 'x/config/styles'
import XText from 'xui/components/XText'
import XIconButton from 'xui/components/XIconButton'
import VStack from 'xui/components/VStack'
import XButton from 'xui/components/XButton'
import assets from 'xui/assets'
import * as NavActions from 'x/utils/navigation'

import { isIphoneX, getStatusBarHeight } from '../../utils/iphone-x-helper'

// const storeShadowBG = require('../../../images/store_shadow_bg.png')
const storeShadowBG = assets.images.storeShadowBg

class StoreSellerView extends Component {
  static displayName = 'StoreSellerView'
  // static propTypes = {
  //   navigation: PropTypes.object.isRequired,
  // }

  static navigationOptions = ({ navigation }) => ({ header: null })

  constructor(props) {
    super(props)
    this.state = {
      hasSellerStoreData: false,
    }
  }

  componentDidMount() {
    const params = util.getNavParams(this.props)
    console.log('StoreSellerView componentDidMount params=', params)
    const { id, name, cover_thumbnail_uri, description, role_id } = params.rowData
    console.log('cover_thumbnail_uri !! => ', cover_thumbnail_uri)
    // util.assert(id, "Required seller's store id in nav params!!")
    // util.assert(name, "Required seller's store name in nav params!!")
    if (id && name) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      setTimeout(() => this.setState({ hasSellerStoreData: true, cover_thumbnail_uri, description, role_id, id, name }), 100)
    }
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (this.isUnmounting) {
  //     return false
  //   }
  //   return util.isDiff(this.state, nextState, ['hasSellerStoreData', 'id', 'name',
  //     'thumbnail_uri', 'cover_thumbnail_uri', 'img_uri', 'description'])
  // }

  _renderCustomHeader() {
    const { navigation } = this.props
    // const { state, goBack } = navigation
    const { id, name, thumbnail_uri, cover_thumbnail_uri, img_uri, description } = this.state
    const isIOS = Platform.OS === 'ios'
    // const stausBarHeight = isIOS ? 12 : 0
    console.log('cover_thumbnail_uri => ', cover_thumbnail_uri)
    let stausBarHeight = getStatusBarHeight()
    const additionHeight = Platform.OS === 'ios' && isIphoneX() ? 10 : 0
    if (additionHeight) {
      stausBarHeight += additionHeight
    }

    const { width, height } = Dimensions.get('window') // screen width / height
    const coverImageRatio = 1.7748917749
    let calculationHeight = parseInt(width / coverImageRatio)
    if (calculationHeight > 210) {
      calculationHeight = 210
    }
    util.log('++++Dimensions width, height => ', width, height)

    return (
      <ImageBackground
        source={cover_thumbnail_uri ? { uri: cover_thumbnail_uri } : null}
        style={{ marginTop: 0, height: calculationHeight }}>
        <ImageBackground
          source={storeShadowBG}
          resizeMode='stretch'
          style={{
            height: calculationHeight,
            flexDirection: 'column',
            paddingTop: stausBarHeight,
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}>
          <View style={{ flexDirection: 'row', marginLeft: 6, marginTop: 6, height: 30 }}>
            <XIconButton
              zIndex={999}
              // variant='outline'
              borderWidth='0'
              // bg='rgba(88,88,88,0.6)'
              _light={{
                bg: 'black:alpha.10',
              }}
              _dark={{
                bg: 'white.alpha.10',
              }}
              borderRadius='full'
              name='arrow-back'
              // transparent
              onPress={() => {
                util.navGoBack(this.props)
              }}
            />
            {/* <View style={{ flex: 6, height: 50, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }} />
            <View style={{ flex: 2, height: 50, flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }} /> */}
          </View>
          <View style={[STYLES.NO_MARGIN_PADDING, { flex: 1, flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end' }]}>
            <XText
              style={{
                fontSize: STYLES.FONT_SIZE_LARGER_2,
                fontWeight: 'bold',
                color: COLORS.TEXT_ACTIVE_DARK,
                marginLeft: 15,
                marginBottom: 15,
                maxWidth: width - 20,
                backgroundColor: 'transparent',
              }}>
              {name}
            </XText>
          </View>
        </ImageBackground>
      </ImageBackground>
    )
  }

  _renderDescription() {
    // const description = this.state.description || null
    const { description } = this.state
    const txtDesc = _.isString(description) && description.length > 0 ? description : '(ไม่มีคำอธิบายร้าน)'
    return (
      <VStack w='full'>
        <XText variant='inactive' bold>
          คำอธิบายร้าน
        </XText>
        <XText>{txtDesc}</XText>
      </VStack>
    )
  }

  _renderMenuList() {
    const { leaveFromSellerStore } = this.props

    // const textStyleActive = { fontSize: STYLES.FONT_SIZE_NORMAL, color: COLORS.TEXT_ACTIVE }
    // const textStyleInactive = { fontSize: STYLES.FONT_SIZE_NORMAL, color: COLORS.TEXT_INACTIVE }

    return (
      <VStack w='full' flex={1} space='1'>
        <VStack w='full' flex={1} space='1'>
          <TouchableOpacity onPress={() => this._viewSellersProducts()}>
            <HStack w='full' px='3' py='2' space='2' borderColor='muted.100' borderWidth='1' borderRadius='lg'>
              <XIcon name='cart' />
              <XText flex={1}>ดูสินค้าในร้านผู้ขายส่ง</XText>
              <XIcon name='arrow-forward' />
            </HStack>
          </TouchableOpacity>

          <TouchableOpacity onPress={() => this._pullProductToMyStore()}>
            <HStack w='full' px='3' py='2' space='2' borderColor='muted.100' borderWidth='1' borderRadius='lg'>
              <XIcon name='cart' />
              <XText flex={1}>ดึงสินค้าเข้าสู่ร้านฉัน</XText>
              <XIcon name='arrow-forward' />
            </HStack>
          </TouchableOpacity>

          {/* <TouchableOpacity onPress={() => Alert.alert('เร็วๆ นี้')}>
          <HStack w='full' px='3' py='2' space='2' borderColor='muted.100' borderWidth='1' borderRadius='lg'>
            <XIcon name='stats' />
            <XText flex={1} variant='inactive'>
              รายงานออเดอร์ที่เปิดกับร้านนี้
            </XText>
            <XIcon name='arrow-forward' />
          </HStack>
        </TouchableOpacity> */}

          {/* <ListItem icon onPress={ () => this._leaveFromThisStore() }> */}
          {/* <Left> */}
          {/* <XIcon name='exit' style={{ color: COLORS.BRAND_Danger }} /> */}
          {/* </Left> */}
          {/* <Body> */}
          {/* <XText style={{ color: COLORS.BRAND_Danger }}>ออกจากการเป็นตัวแทนร้านนี้</XText> */}
          {/* </Body> */}
          {/* <Right> */}
          {/* <XIcon name='arrow-forward' style={{ color: COLORS.TEXT_PRIMARY }} /> */}
          {/* </Right> */}
          {/* </ListItem> */}
        </VStack>
        <XButton variant='outline' colorScheme='danger' onPress={this._leaveFromThisStore}>
          ออกจากการเป็นตัวแทนร้านนี้
        </XButton>
      </VStack>
    )
  }

  _viewSellersProducts() {
    const { navigation, myStores } = this.props
    const { id } = this.state
    // if (id) {
    //   const store_id = myStores.getIn([0, 'id'])
    //   navigation.dispatch(NavActions.navToProductListSeller({ store_id, seller_store_id: id }))
    // }
    if (id) {
      navigation.dispatch(NavActions.navToProductListViewSellersStore({ seller_store_id: id }))
    }
  }

  _pullProductToMyStore() {
    const { myStores } = this.props
    const { id } = this.state

    if (id) {
      if (myStores.size > 1) {
        setTimeout(() => this._selectMyStoreToPullProductList({ myStores, seller_store_id: id }), 200)
      } else if (myStores.size === 1) {
        const store_id = myStores.getIn([0, 'id'])
        this._goToPullProductList({ store_id, seller_store_id: id })
      } else {
        // Should be Impossible case
        Alert.alert('You do not have your Stores.')
      }
    }
  }

  _leaveFromThisStore = () => {
    const { leaveFromStore, navigation } = this.props
    // const { goBack, state } = navigation
    const { id, name } = this.state
    // console.log('_leaveFromThisStore id, name => ', id, name)
    if (id) {
      p.op.showConfirmation(
        'ออกจากการเป็นตัวแทน',
        'หากออกจากการเป็นตัวแทน สินค้าที่คุณเคยดึงเข้าร้านจะถูกลบออกจากร้านฉัน (และร้านตัวแทนคุณทั้งหมด ถ้ามี) ' +
          'แต่ออเดอร์ที่เคยเปิดไว้กับทางร้าน จะยังสามารถดูย้อนหลังและดำเนินการได้จนเสร็จสิ้น' +
          `\n\nคุณยืนยันที่จะออกจากการเป็นตัวแทนร้าน ${name} หรือไม่`,
        () => {
          const body = { store_id: id }
          const successCallback = () => {
            p.op.showToast(`คุณได้ออกจากการเป็นตัวแทนของร้าน ${name} นี้แล้ว`, 'success')
            // @ts-ignore
            const params = util.getNavParams(this.props)
            // @ts-ignore
            const { callBackLeaveSuccess } = params
            if (_.isFunction(callBackLeaveSuccess)) {
              callBackLeaveSuccess()
            }
            // @ts-ignore
            util.navGoBack(this.props)
          }
          const failedCallback = () => {
            // @ts-ignore
            util.navGoBack(this.props)
          }
          leaveFromStore({ body, successCallback, failedCallback })
        },
        null,
        'ยืนยัน',
        'ยกเลิก'
      )
    }
  }

  _selectMyStoreToPullProductList({ myStores, seller_store_id }) {
    const BTN_LABELS = []
    myStores.forEach((store) => {
      BTN_LABELS.push(store.get('name'))
    })
    BTN_LABELS.push('ยกเลิก')
    p.op.showActionSheet(
      {
        options: BTN_LABELS,
        cancelButtonIndex: BTN_LABELS.length - 1,
        // destructiveButtonIndex: -1,
        title: 'ดึงสินค้าเข้าร้าน...',
      },
      (buttonIndex) => {
        const idx = parseInt(buttonIndex)
        if (idx < 1) {
          return
        }
        if (idx < BTN_LABELS.length - 1) {
          const store_id = myStores.getIn([idx, 'id'])
          this._goToPullProductList({ store_id, seller_store_id })
        }
      }
    )
  }

  _goToPullProductList({ store_id, seller_store_id }) {
    // this.props.navigation.dispatch(
    //   NavActions.navToProductListPullProduct({
    //     store_id,
    //     seller_store_id,
    //   })
    // )
    this.props.navigation.dispatch(
      NavActions.navToProductListViewPullSellersProductsToMyStore({
        store_id,
        seller_store_id,
      })
    )
  }

  render() {
    util.logRender(this)
    const { hasSellerStoreData } = this.state
    return (
      <XContainer>
        {/* {hasSellerStoreData ? this._renderCustomHeader() : null} */}
        {this._renderCustomHeader()}
        <VStack flex={1} w='full' px='3' py='2' space='1'>
          {this._renderDescription()}
          {this._renderMenuList()}
        </VStack>
      </XContainer>
    )
  }
}
//
// const s1 = {
//   actBtnText: {
//     fontSize: 18,
//   },
//   actBtnTextContainer: {
//     height: 34,
//     marginTop: -6,
//   },
// }
export default StoreSellerView
